export const USER_URL = 'user/';
export const SIGN_UP_URL = 'sign-up/';
